import React, { ReactNode } from "react";
import classNames from "classnames";
import { GatsbyLinkProps, Link } from "gatsby";

/** Avoid ref issue: https://github.com/gatsbyjs/gatsby/issues/16682 */
type CustomGatsbyLink = Omit<GatsbyLinkProps<Record<string, unknown>>, "ref">;

export type LinkButtonProps = CustomGatsbyLink & {
  children: ReactNode;
  /** Main color of AccuRank */
  color?: "purple" | "orange" | "lightPurple" | "green";
  /** If the text in button should always be in one line */
  wrap?: boolean;
};

const LinkButton = ({
  children,
  color,
  wrap = false,
  className,
  to,
  ...props
}: LinkButtonProps) => {
  if (!to.startsWith("http") && !to.endsWith("/")) {
    to = `${to}/`;
  }

  return (
    <Link
      to={to}
      className={classNames(
        `rounded-md px-4 py-2 font-medium text-white transition-colors duration-300 ${className}`,
        {
          "bg-accuRankerPurpleOpacity-dark hover:bg-accuRankerPurpleOpacity-light":
            color === "purple",
          "bg-accuRankerPurple-500 hover:bg-accuRankerPurple-400":
            color === "lightPurple",
          "bg-accuRankerOrange-500 hover:bg-accuRankerOrange-900":
            color === "orange",
          "bg-accuRankerGreen-500 hover:bg-accuRankerGreen-600":
            color === "green",
          "whitespace-nowrap": wrap,
        }
      )}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
